import React, { useState, useEffect } from 'react';

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToBooking = () => {
        const bookingSection = document.querySelector('.booking-widget');
        if (bookingSection) {
            bookingSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <nav className={`navbar ${scrolled ? 'scrolled' : ''} glass-panel`}>
            <div className="nav-logo">
                <h2>Cabanas de Vidro</h2>
            </div>
            <ul className="nav-links">
                <li><a href="#hero">Início</a></li>
                <li><a href="#chalets">Chalés</a></li>
                <li><a href="#amenities">Confortos</a></li>
                <li><a href="#location">Localização</a></li>
                <li><a href="#contact">Contato</a></li>
            </ul>
            <button className="nav-cta" onClick={scrollToBooking}>
                Reservar
            </button>
        </nav>
    );
};

export default Navbar;
